/* eslint-disable */
import { NgClass } from "@angular/common";
import { Component, EventEmitter, Input, Output, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { KeeniconComponent } from "@shared/keenicon/keenicon.component";
import { NgxMaskDirective } from "ngx-mask";
import { BasicFormInputComponent } from "../../basic/basic-form-input.component";
import { CabLabelComponent } from "../cab-label/cab-label.component";

@Component({
  selector: "app-cab-input",
  templateUrl: "./cab-input.component.html",
  styleUrls: ["./cab-input.component.scss"],
  standalone: true,
  imports: [
    NgClass,
    CabLabelComponent,
    FormsModule,
    NgxMaskDirective,
    ReactiveFormsModule,
    KeeniconComponent,
    TranslateModule,
  ],
})
export class CabInputComponent extends BasicFormInputComponent {
  eyeIconToggle = signal(false);

  defaultPasswordStyleInHide = {
    margin: "0 !important",
    padding: "0 !important",
    bottom: "30px",
    top: "13px",
    width: "20px",
    height: "20px",
  };

  defaultPasswordStyleInShow = {
    margin: "0 !important",
    padding: "0 !important",
    bottom: "30px",
    top: "14px",
    width: "20px",
    height: "20px",
  };

  @Output() onInput = new EventEmitter();
  @Output() focus = new EventEmitter<FocusEvent>();
  @Output() blur = new EventEmitter<FocusEvent>();
  @Input() type:
    | "text"
    | "number"
    | "password"
    | "email"
    | "date"
    | "search"
    | "time"
    | "hidden" = "text";
  @Input() svgIcon = "";
  @Input() iconButton = "";
  @Input() keenIconName = "";
  @Input() keenIconClass = "";
  @Input() inputTypePasswordStyleHide: any = this.defaultPasswordStyleInHide;
  @Input() inputTypePasswordStyleShow: any = this.defaultPasswordStyleInShow;
  @Input() readonly = false;
  @Input() mask = "";
  @Input() prefix = "";
  @Input() suffix = "";
  @Input() step = "";
  @Input() allowNegativeNumbers = false;
  @Input() dropSpecialCharacters = true;
  @Input() showMaskTyped = false;
  @Input() isPending = false;
  @Input() thousandSeparator: string = " ";
  @Input() patterns: any;
  @Input() max = Infinity;
  @Input() min = -Infinity;
  @Input() autocomplete = "on";

  togglePasswordType() {
    this.eyeIconToggle.set(!this.eyeIconToggle());
    if (this.type == "password") {
      this.type = "text";
    } else if (this.type == "text") {
      this.type = "password";
    }
  }

  handleFocus(event: FocusEvent) {
    this.focus.emit(event);
  }

  handleBlur(event: FocusEvent) {
    this.blur.emit(event);
  }
}
